import { create } from 'zustand';

interface ProcedureExecutionStore {
  panelOpen: boolean;
  expandedSections: Set<string>;
  expandedStepIds: Set<string>;
  dirtyStepIds: Set<string>;

  setPanelOpen: (open: boolean) => void;
  toggleSection: (sectionId: string) => void;
  toggleStep: (stepExecId: string) => void;
  expandStep: (stepExecId: string) => void;
  collapseStep: (stepExecId: string) => void;
  markDirty: (stepExecId: string) => void;
  markClean: (stepExecId: string) => void;
  reset: () => void;
}

const INITIAL: Pick<ProcedureExecutionStore, 'panelOpen' | 'expandedSections' | 'expandedStepIds' | 'dirtyStepIds'> = {
  panelOpen: false,
  expandedSections: new Set<string>(),
  expandedStepIds: new Set<string>(),
  dirtyStepIds: new Set<string>(),
};

export const useProcedureExecutionStore = create<ProcedureExecutionStore>((set) => ({
  ...INITIAL,

  setPanelOpen: (open) => set({ panelOpen: open }),

  toggleSection: (sectionId) =>
    set((s) => {
      const next = new Set(s.expandedSections);
      if (next.has(sectionId)) next.delete(sectionId);
      else next.add(sectionId);
      return { expandedSections: next };
    }),

  toggleStep: (stepExecId) =>
    set((s) => {
      const next = new Set(s.expandedStepIds);
      if (next.has(stepExecId)) next.delete(stepExecId);
      else next.add(stepExecId);
      return { expandedStepIds: next };
    }),

  expandStep: (stepExecId) =>
    set((s) => ({ expandedStepIds: new Set([...s.expandedStepIds, stepExecId]) })),

  collapseStep: (stepExecId) =>
    set((s) => {
      const next = new Set(s.expandedStepIds);
      next.delete(stepExecId);
      return { expandedStepIds: next };
    }),

  markDirty: (stepExecId) =>
    set((s) => ({ dirtyStepIds: new Set([...s.dirtyStepIds, stepExecId]) })),

  markClean: (stepExecId) =>
    set((s) => {
      const next = new Set(s.dirtyStepIds);
      next.delete(stepExecId);
      return { dirtyStepIds: next };
    }),

  reset: () => set({ ...INITIAL, expandedSections: new Set(), expandedStepIds: new Set(), dirtyStepIds: new Set() }),
}));
